import {
  GET_CAR_MODEL_LIST_REQUEST,
  GET_CAR_MODEL_LIST_SUCCESS,
  GET_CAR_MODEL_LIST_FAIL,
  GET_SINGLE_CAR_MODEL_REQUEST,
  GET_SINGLE_CAR_MODEL_SUCCESS,
  GET_SINGLE_CAR_MODEL_FAIL,
  DELETE_CAR_MODEL_REQUEST,
  DELETE_CAR_MODEL_SUCCESS,
  DELETE_CAR_MODEL_FAIL,
  ADD_CAR_MODEL_REQUEST,
  ADD_CAR_MODEL_SUCCESS,
  ADD_CAR_MODEL_FAIL,
  UPDATE_CAR_MODEL_REQUEST,
  UPDATE_CAR_MODEL_SUCCESS,
  UPDATE_CAR_MODEL_FAIL,
} from "src/constants/types";

export const carModelReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_CAR_MODEL_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_CAR_MODEL_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        carModels: actions.payload,
        error: "",
      };
    case GET_CAR_MODEL_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_CAR_MODEL_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_CAR_MODEL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_CAR_MODEL_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_CAR_MODEL_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_CAR_MODEL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_CAR_MODEL_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_CAR_MODEL_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_CAR_MODEL_SUCCESS:
      return {
        ...state,
        loading: false,
        carModel: actions.payload,
      };
    case GET_SINGLE_CAR_MODEL_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_CAR_MODEL_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_CAR_MODEL_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_CAR_MODEL_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
